// extracted by mini-css-extract-plugin
export var numpadContainer = "_oj-1";
export var phoneButton = "_oj-0";